export const windowBreakpoints = {
  xsMinWidth: 320 /* Mobile (portrait) */,
  smMinWidth: 479 /* Tablet */,
  mdMinWidth: 800 /* Small screens & Landscape tablets */,
  lgMinWidth: 1230 /* Laptop */,
  xlMinWidth: 1401 /* Desktop, laptop */,
  xxlMinWidth: 1513 /* Large displays */,
};
